export default __webpack_public_path__ + "static/media/U_wdt_c_cap_3.22202442.mp3";